import { DEFAULT_LOCATION } from '../constants'

export const addRegionToUrl = (url: string, region: string | undefined) => {
  return url + `&region=${region || DEFAULT_LOCATION.value}`
}
